import { Employee } from '../../model/employee/employee.model';

export const EMPLOYEES: Employee[] = [
];
